import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { faqs, transformBg } from '../mock';

const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section className="section">
      <div className="section-bg" style={{ backgroundImage: `url(${transformBg})`, opacity: 0.04 }} />
      <div className="section-inner">
        <div className="section-head">
          <div className="section-label">Sık Sorulan Sorular</div>
          <h2 className="section-title">
            Merak <span className="accent">Ettikleriniz</span>
          </h2>
        </div>
        <div className="faq-list">
          {faqs.map((f, i) => (
            <div key={i} className={`faq-item ${open === i ? 'open' : ''}`}>
              <button className="faq-q" onClick={() => setOpen(open === i ? -1 : i)}>
                <span>{f.q}</span>
                <Plus className="faq-icon" size={20} />
              </button>
              {open === i && (
                <div className="faq-a">{f.a}</div>
              )}
            </div>
          ))}
        </div>
        <div className="faq-cta">
          <p>Sorunuzu burada bulamadınız mı?</p>
          <a className="btn-primary" href="https://wa.me/905544356351" target="_blank" rel="noreferrer">
            WhatsApp&apos;tan Sorun
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
